import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Login } from './Login'

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  login (details: Login): Observable<any> {
    return this.http.post<any>('/core-service/api/login', details).pipe(
      tap((some: any) => console.log('dunno: ', some))
    );
  }

  xlogin (details: Login): Observable<any> {
    return this.http.post<any>('/account/login', 'username=' + details.username + '&password=' + details.password).pipe(
      tap((some: any) => console.log('dunno: ', some)),
      catchError(this.handleError<any>('login'))
    );
  }


  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
   
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
   
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
   
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
